import { useContext } from "react";

import { Context } from "../teacherStore";

const useAppOrderStatus = () => {
  const { state } = useContext(Context);

  const hasG4sAndDlpOrder = state.has_g4s_order && state.has_dlp_order;

  const hasOnlyG4sOrder = state.has_g4s_order && !state.has_dlp_order;

  const hasOnlyDlpOrder =
    !state.has_g4s_order && state.has_dlp_order && !state.has_g4s_basic_order;

  const hasDlpAndG4sBasicOrder =
    !state.has_g4s_order && state.has_dlp_order && state.has_g4s_basic_order;

  const hasOnlyG4sBasicOrder =
    !state.has_g4s_order && !state.has_dlp_order && state.has_g4s_basic_order;

  return {
    hasG4sAndDlpOrder,
    hasOnlyG4sOrder,
    hasOnlyDlpOrder,
    hasDlpAndG4sBasicOrder,
    hasOnlyG4sBasicOrder,
  };
};

export default useAppOrderStatus;
